import React from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../utils/analytics';

const Hero = () => {
  const handleDemoClick = () => {
    trackButtonClick('request_demo', 'hero_section');
  };

  return (
    <section className="py-36 bg-black text-white" style={{ backgroundImage: "url('/images/hero-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundBlendMode: 'overlay' }}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            <span className="text-blue-500">Automated</span> Red<br />
            Teaming<br />
            for Enterprise AI
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Detect and mitigate vulnerabilities in your AI applications before attackers
            exploit them.
          </p>
          <div className="flex space-x-4">
            <Link to="/demo" className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded" onClick={handleDemoClick}>
              Get a Demo
            </Link>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Hero;